module.exports = __webpack_public_path__ + "img/latest-updates.6ef271e7.png";